import { useCallback } from "react";

import { useScreen0Language } from "@/features/language";
import { formatTemplate, getTranslations } from "@/i18n";

import { HeaderTextToggle } from "../habits/HabitsHeaderToggles";

export type PeriodMode = "day" | "week" | "month";

const PERIOD_CYCLE: readonly PeriodMode[] = ["day", "week", "month"];

function nextPeriodMode(current: PeriodMode): PeriodMode {
  const index = PERIOD_CYCLE.indexOf(current);
  return PERIOD_CYCLE[(index + 1) % PERIOD_CYCLE.length]!;
}

const PERIOD_TOGGLE_CLASS = "today-period-toggle shrink-0";
const PERIOD_LABEL_CLASS = "col-start-1 row-start-1 whitespace-nowrap";

export function PeriodMenu({
  mode,
  onModeChange,
}: {
  mode: PeriodMode;
  onModeChange: (mode: PeriodMode) => void;
}) {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);

  const periodLabels: Record<PeriodMode, string> = {
    day: t.today.periodDay,
    week: t.today.periodWeek,
    month: t.today.periodMonth,
  };
  const stableWidthLabels = [t.today.periodDay, t.today.periodWeek, t.today.periodMonth];

  const cycleMode = useCallback(() => {
    onModeChange(nextPeriodMode(mode));
  }, [mode, onModeChange]);

  return (
    <HeaderTextToggle
      label={periodLabels[mode]}
      onClick={cycleMode}
      ariaLabel={formatTemplate(t.today.periodToggleAria, { period: periodLabels[mode] })}
      animateKey={mode}
      toggleClassName={PERIOD_TOGGLE_CLASS}
      labelClassName={PERIOD_LABEL_CLASS}
      stableWidthLabels={stableWidthLabels}
    />
  );
}
